import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../components/PdfRender';
import { RSignature } from '../../../components/PdfRender/RSignature';
import { useCompany } from '../../../hooks/company';
import { IDentalTreatment } from '../../interfaces';
import { formatDate } from '../../utils/format-date';
import { styles } from './styles';
import { useAuth } from '../../../hooks/auth';

interface IDentalTreatmentEvolutionLog {
  id: string;
  date: string;
  time: string;
  rank: number;
  status: number;
  observation: string;
  professional_id?: string;
  signed_professional_name?: string;
  signed_professional_signature?: string | null;
  signature_validation_code?: string;
  signed_at?: string;
}

interface IDentalTreatmentEvolutionReportProps {
  treatment: IDentalTreatment | null;
  logs: IDentalTreatmentEvolutionLog[];
}

const statusLabel: Record<number, string> = {
  0: 'Pendente',
  1: 'Em andamento',
  2: 'Concluido',
};

export const DentalTreatmentEvolutionReport: React.FC<
  IDentalTreatmentEvolutionReportProps
> = ({ treatment, logs }) => {
  const { company } = useCompany();
  const { clinic } = useAuth();

  return (
    <RViewer>
      <RPage>
        <View style={styles.container}>
          <RHeader company={company} />

          <View style={styles.card}>
            <Text style={styles.title}>
              Evolucao do Tratamento Odontologico
            </Text>
            <View style={styles.row}>
              <Text style={styles.label}>N:</Text>
              <Text style={styles.value}>{treatment?.code || '-'}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Paciente:</Text>
              <Text style={styles.value}>{treatment?.client_name || '-'}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Profissional:</Text>
              <Text style={styles.value}>
                {treatment?.professional_name || '-'}
              </Text>
            </View>
          </View>

          <View style={styles.tableHead}>
            <View style={styles.colDate}>
              <Text style={styles.tableHeadText}>Data</Text>
            </View>
            <View style={styles.colTime}>
              <Text style={styles.tableHeadText}>Hora</Text>
            </View>
            <View style={styles.colStatus}>
              <Text style={styles.tableHeadText}>Status</Text>
            </View>
            <View style={styles.colRank}>
              <Text style={styles.tableHeadText}>Rank</Text>
            </View>
            <View style={styles.colObservation}>
              <Text style={styles.tableHeadText}>Observacao</Text>
            </View>
          </View>

          {logs.map((log) => (
            <View key={log.id}>
              <View style={styles.tableRow}>
                <View style={styles.colDate}>
                  <Text style={styles.tableCell}>{formatDate(log.date)}</Text>
                </View>
                <View style={styles.colTime}>
                  <Text style={styles.tableCell}>{log.time || '-'}</Text>
                </View>
                <View style={styles.colStatus}>
                  <Text style={styles.tableCell}>
                    {statusLabel[Number(log.status)] || 'Pendente'}
                  </Text>
                </View>
                <View style={styles.colRank}>
                  <Text style={styles.tableCell}>{Number(log.rank || 0)}</Text>
                </View>
                <View style={styles.colObservation}>
                  <Text style={styles.tableCell}>{log.observation || '-'}</Text>
                </View>
              </View>

              {(log.signature_validation_code || log.signed_at) && (
                <RSignature
                  professional_name={treatment?.professional_name}
                  signer_name={
                    log.signed_professional_name || treatment?.professional_name
                  }
                  signature={log.signed_professional_signature || null}
                  validation_code={log.signature_validation_code || null}
                  signed_at={log.signed_at || null}
                  separate_page_when_signed
                  clinic={clinic}
                />
              )}
            </View>
          ))}
        </View>
      </RPage>
    </RViewer>
  );
};
